import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./ModalParticularPcr.css";

const ModalParticularPcr = ({
  titulo,
  textoNegrita,
  texto,
  dissmiss,
  danger,
  onClickCancelar,
  onClickAceptar,
  dto,
}) => {
  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={danger} />

      {(texto || textoNegrita) && (
        <div className="ptur-modalBody-mensaje">
          {textoNegrita && (
            <h3 className="rb16m c-latex10">
              {textoNegrita === "" ? "Error inesperado." : textoNegrita}
            </h3>
          )}
          {texto && (
            <h3 className="rb16t c-latex10">{texto === "" ? "" : texto}</h3>
          )}
          <hr className="pcr-modalBody-separador" />
          {dto && (
            <div className="pcr-modalBody-container-datosTurno">
              <div className="pcr-modalBody-datosTurno">
                <span className="rb16m c-latex10">{dto.medico}</span>
                <span className="rb16m c-latex10">
                  <span className="rb16t">Horario:</span> {dto.hora}
                </span>
                <span className="rb16m c-latex10">
                  {getDiaStrTurno(dto.fecha)}{" "}
                  <span className="rb18l">
                    {getDiaStrTurno(dto.fecha, true)}
                  </span>
                </span>

                <span className="rb16m c-latex10">{dto.ubicacion}</span>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="ptur-modalContainerBoton-pcrParticular">
        <button
          onClick={onClickCancelar}
          className="btn-Mensaje b-latex30 c-latex30 rb16m"
        >
          Cancelar
        </button>
        <button
          onClick={onClickAceptar}
          className="btn-Mensaje rb16m bgc-latex10 c-white"
        >
          Tomar como particular
        </button>
      </div>
    </>
  );
};

export default ModalParticularPcr;
